"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SAMPLE_DATA = exports.MULTI_ROOM_DATA = exports.ENDPOINT_CONFIG = exports.DROPDOWN_DATA = exports.DATE_FORMAT_DATA = void 0;
var SAMPLE_DATA = {
  components: [{
    data: [{
      type: 'heroBanner',
      id: 'heroBanner',
      iconName: '',
      label1: '',
      label2: '',
      redirectUrl: 'www.airasia.com',
      placeholderText: '',
      showInDesktop: 'FALSE',
      showInMobile: 'TRUE',
      imageUrl: 'https://storage.googleapis.com/hotel-icons/stg-hotel-search-banner.jpg'
    }, {
      type: 'placepicker',
      id: 'originDestionation',
      iconName: 'LocationOnIcon',
      label1: 'Destination',
      label2: 'To',
      redirectUrl: '',
      placeholderText: 'Try {0}',
      notFoundText: "We can't find anything for {0}",
      showInDesktop: 'TRUE',
      showInMobile: 'TRUE',
      defaultLocation: 'Kuala Lumpur',
      placeholderItems: ['kul', 'pen', 'tgg']
    }, {
      type: 'datepicker',
      id: 'datepicker',
      iconName: 'calendarIcon',
      label1: 'Check-in',
      label2: 'Check-out',
      redirectUrl: '',
      placeholderText: '',
      showInDesktop: 'TRUE',
      showInMobile: 'TRUE'
    }, {
      type: 'multi_room_select',
      id: 'guest_rooms',
      iconName: 'userIcon',
      label1: 'Guest & Rooms',
      label2: '',
      redirectUrl: '',
      placeholderText: '',
      showInDesktop: 'TRUE',
      showInMobile: 'TRUE',
      enableAgeInput: 'TRUE',
      hideInfantSelect: 'TRUE'
    }, {
      type: 'passenger_counter',
      id: 'passenger_counter',
      iconName: '',
      label1: '',
      label2: '',
      redirectUrl: '',
      placeholderText: '',
      showInDesktop: 'TRUE',
      showInMobile: 'TRUE'
    }, {
      type: 'button',
      id: 'search_button',
      iconName: '',
      label1: 'Search',
      label2: '',
      redirectUrl: '',
      placeholderText: '',
      showInDesktop: 'TRUE',
      showInMobile: 'TRUE'
    }, {
      type: 'bottomBanner',
      id: 'bottomBanner',
      imageURL: 'https://a.staticaa.com/images/campaign/hero-banner/INTHISTOGETHER_HEROBANNER_21Apr2020.jpg',
      headline: 'This is a Banner Headline',
      subheadline: 'This is a Banner SubHeadline',
      headlineColor: 'tertiaryLight',
      subheadlineColor: 'tertiaryLight',
      buttonText: 'AirAsia.com Website',
      buttonUrl: 'https://www.airasia.com/',
      redirectUrl: 'https://www.airasia.com/',
      showInDesktop: 'TRUE',
      showInMobile: 'FALSE'
    }]
  }, {
    data: [{
      type: 'dropdown',
      id: 'destination',
      iconName: '',
      label1: 'Destination',
      label2: '',
      redirectUrl: '',
      placeholderText: '',
      showInDesktop: 'TRUE',
      showInMobile: 'TRUE'
    }, {
      type: 'link',
      id: 'multi_city',
      iconName: '',
      label1: 'Multi-city',
      label2: '',
      redirectUrl: 'www.airasia.com',
      placeholderText: '',
      showInDesktop: 'TRUE',
      showInMobile: 'TRUE'
    }, {
      type: 'checkbox',
      id: 'big_points',
      iconName: '',
      label1: 'Redeem Big Points',
      label2: '',
      redirectUrl: '',
      placeholderText: '',
      showInDesktop: 'TRUE',
      showInMobile: 'TRUE'
    }]
  }],
  badges: [{
    data: [{
      type: 'city',
      label: 'City',
      icon: 'locationIcon'
    }, {
      type: 'airport',
      label: 'Airport',
      icon: 'airplaneIcon'
    }, {
      type: 'hotel',
      label: 'Hotel',
      icon: 'hoteIcon'
    }, {
      type: 'landmark',
      label: 'Landmark',
      icon: 'golfIcon'
    }]
  }],
  roomConfig: [{
    data: [{
      minRooms: '1',
      maxRooms: '12',
      minPassengers: '1',
      maxPassengers: '12',
      maxPassengersPerRoom: 5
    }]
  }, {
    adult: [{
      min: '1',
      max: '12'
    }]
  }, {
    child: [{
      min: '0',
      max: '11'
    }]
  }, {
    infant: [{
      min: '0',
      max: '11'
    }]
  }],
  passengerConfig: [{
    data: [{
      min: '1',
      max: '9',
      minAdult: '1',
      maxAdult: '',
      minChild: '0',
      maxChild: '',
      minInfant: '0',
      maxInfant: 'adult'
    }]
  }],
  placepickerConfig: [{
    cookie: [{
      recentSearchCookie: 'flightRecentSearch'
    }]
  }, {
    recommendedStations: [{
      stationName: 'Singapore'
    }, {
      stationName: 'Kuala Lumpur'
    }, {
      stationName: 'India'
    }, {
      stationName: 'Europe'
    }]
  }],
  gtmConfig: [{
    data: [{
      event: 'trackEventNoEcommerce',
      eventActionClick: 'click',
      eventActionView: 'view',
      eventCategory: '',
      eventLabelCardClick: '',
      eventLabelHeadlineClick: ''
    }]
  }],
  translations: [{
    data: [{
      calendarSubmitButton: 'Confirm',
      calendarResetButton: 'Reset',
      adultSingle: 'Adult',
      adultPlural: 'Adults',
      childSingle: 'Child',
      childPlural: 'Children',
      infantSingle: 'Infant',
      infantPlural: 'Infants',
      guestSingle: 'Guest',
      guestPlural: 'Guests',
      roomSingle: 'Room',
      roomPlural: 'Rooms',
      adultAgeLimit: '18 years and above',
      childAgeLimit: '2 to 17 years',
      infantAgeLimit: 'Less than 2 years',
      roomTitle: 'Room {0}',
      roomAddButton: 'Add more rooms',
      roomRemoveButton: 'Remove',
      roomSubmitButton: 'Done',
      passengerModalHeaderLabel: 'Select guests and rooms',
      noResultLabel: 'There is no result for {0}',
      lowestFareLabel: 'Lowest all-in fares in {0} for 1 adult',
      recentSearch: 'Recent Searches',
      multiRoomSelectTitle: 'Guests and Rooms',
      childAgeDropdownLabel: 'Child {0} age'
    }]
  }],
  chinaDisclaimer: [{
    data: [{
      cnDisclaimerLine1: '请稍候，您将于 {3} 秒后由 {0} 网站跳转至中国境外网站 {1}。',
      cnDisclaimerLine2: '您的交易是直接与中国境外网站 {1} 的运营主体 {2} 构成合同关系，与亚航商务服务(广州)有限公司无关。',
      cnDisclaimerURL: 'airasia.cn',
      countDownTimer: '5',
      redirectCompanyName: 'AirAsiaCom Travel Sdn Bhd',
      redirectCompanyURL: 'airasia.com',
      redirectionUrl: "https://china.airasiago.com/lp/dailydeals?\n          langid=2052&utm_source=airasia_web&utm_medium=product_tile&utm_campaign=SAH&utm_content=zh-CN",
      productID: 'hotels',
      newTab: 'TRUE'
    }]
  }]
};
exports.SAMPLE_DATA = SAMPLE_DATA;
var ENDPOINT_CONFIG = [{
  id: 'origin',
  endpointID: '',
  endpointUrl: 'www.ppsch.origin/'
}, {
  id: 'destination',
  endpointID: '',
  endpointUrl: 'www.ppsch.destination/{0}'
}, {
  id: 'datepicker',
  endpointID: 'oneway',
  endpointUrl: 'www.ppsch.pricecalendar/depart/{0}/{1}'
}, {
  id: 'datepicker',
  endpointID: 'return',
  endpointUrl: 'www.ppsch.pricecalendar/return/{0}/{1}'
}, {
  id: 'dateFormat',
  endpointID: 'dateFormat',
  endpointUrl: '{static_url}/cosmos/common/date/{locale}/file.json'
}, {
  id: 'datepicker',
  endpointID: 'currency',
  endpointUrl: 'https://ppsch.apiairasia.com/dataformat/currency/{0}/file.json'
}];
exports.ENDPOINT_CONFIG = ENDPOINT_CONFIG;
var MULTI_ROOM_DATA = {
  labels: {
    passengerModalHeaderLabel: 'Select guests and rooms',
    multiRoomSelectTitle: 'Guests and Rooms',
    roomTitle: 'Rooms {0}',
    roomAddButton: 'Add more rooms',
    roomRemoveButton: 'Remove',
    roomSubmitButton: 'Done',
    roomSingle: 'Room',
    roomPlural: 'Rooms',
    guestSingle: 'Guest',
    guestPlural: 'Guests',
    adultSingle: 'Adult',
    adultPlural: 'Adults',
    childSingle: 'Child',
    childPlural: 'Children',
    infantSingle: 'Infant',
    infantPlural: 'Infants',
    adultAgeLimit: '18 years and above',
    childAgeLimit: '2 to 17 years',
    infantAgeLimit: 'Less than 2 years'
  },
  minRooms: 1,
  maxRooms: 9,
  minPassengers: 1,
  maxPassengers: 9,
  maxPassengersPerRoom: 5,
  adult: {
    type: 'adult',
    label: 'Adult',
    subLabel: '18 years and above',
    min: 'infant',
    max: ''
  },
  child: {
    type: 'child',
    label: 'Child',
    subLabel: 'Between 12 years and 17 years',
    min: '0',
    max: ''
  },
  infant: {
    min: '0',
    type: 'infant',
    label: 'Infant',
    subLabel: '0 years',
    max: 'adult'
  },
  roomOccupancy: [// { adult: 1, child: 0, infant: 0 },
    // { adult: 1, child: 0, infant: 0 },
    // { adult: 1, child: 0, infant: 0 },
  ],
  defaultRoomOccupancy: {
    adult: 1,
    child: 0,
    infant: 0
  }
};
exports.MULTI_ROOM_DATA = MULTI_ROOM_DATA;
var DATE_FORMAT_DATA = {
  date: {
    noYear: 'dd mmm',
    fullWithDay: 'ddd, dd mmm',
    noDay: 'mmm yyyy',
    abbreviate: 'dd mmm yyyy',
    general: 'dd/mm/yyyy'
  },
  shortDaysTranslation: {
    wed: 'Wed',
    sun: 'Sun',
    fri: 'Fri',
    tue: 'Tue',
    mon: 'Mon',
    thu: 'Thu',
    sat: 'Sat'
  },
  fullMonthTranslation: {
    mar: 'March',
    feb: 'February',
    aug: 'August',
    sep: 'September',
    apr: 'April',
    jun: 'June',
    jul: 'July',
    jan: 'January',
    may: 'May',
    nov: 'November',
    dec: 'December',
    oct: 'October'
  },
  letterDaysTranslation: {
    wed: 'W',
    sun: 'S',
    fri: 'F',
    tue: 'T',
    mon: 'M',
    thu: 'T',
    sat: 'S'
  }
};
exports.DATE_FORMAT_DATA = DATE_FORMAT_DATA;
var DROPDOWN_DATA = {
  locale: {
    noResultLabel: 'There is no result for {0}',
    loadOptions: 'Options are loading',
    recentSearch: 'Recent Searches'
  }
};
exports.DROPDOWN_DATA = DROPDOWN_DATA;